import { CommunityEventMilestone } from '../../state/communityJackpot.types';

export const getOtherPrizes = (prizes: CommunityEventMilestone['prizes']) =>
  prizes
    .filter((prize) => prize.rewardType === 'Prize')
    .sort((p1, p2) => p2.rewardAmount - p1.rewardAmount);
